var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:download"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.0006 21.3333L9.33398 14.6667L11.2006 12.7333L14.6673 16.2V5.33333H17.334V16.2L20.8006 12.7333L22.6673 14.6667L16.0006 21.3333ZM8.00065 26.6667C7.26732 26.6667 6.63976 26.4058 6.11798 25.884C5.59621 25.3622 5.33487 24.7342 5.33398 24V20H8.00065V24H24.0006V20H26.6673V24C26.6673 24.7333 26.4064 25.3613 25.8846 25.884C25.3629 26.4067 24.7349 26.6675 24.0006 26.6667H8.00065Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.1bc918df8cd1e9c4c42d469f2e0fc20a.svg";
export { ForwardRef as ReactComponent };